module.exports = __webpack_public_path__ + "static/media/S (84).2dc7c264.jpg";